// File Metadata:
// Filename: index.js
// Version: 1.00
// Created: 2022-08-23 17:19:08
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { store } from './app/store'
import { Provider } from 'react-redux'

import { disableReactDevTools } from '@fvilers/disable-react-devtools'
import { ThemeProvider } from '@mui/material'
import { theme } from './theme'
import { CONSTANT } from './config/constants'
const { development } = CONSTANT
if (process.env.NODE_ENV === 'production') disableReactDevTools()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<BrowserRouter>
					<Routes>
						<Route path='/*' element={<App />} />
					</Routes>
				</BrowserRouter>
			</ThemeProvider>
		</Provider>
	</React.StrictMode>
)
